class FormFlowInitiator {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        const config  = JSON.parse(this.options.formflowConfig); // contentUrl, type, context, previousPage
        const { contentUrl, context, timeout } = config;
        this.contentUrl = contentUrl;
        this.context = context;
        this.modal = document.querySelector('.modal');
        this.container = null;
        this.loader = null;
        this.timeout = timeout || 20000;

        this.fetchProps = {
            credentials: "include",
            method: "GET",
            mode: "cors",
            headers: {
                Accept: "application/text",
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8"
            }
        };

        this.errorTemplate = `
            <div class="page">
                <header class="page__header">
                    <h2 class="page__heading">Er is iets fout gegaan</h2>
                </header>
                <div class="page__content">
                    <div class="page__list">
                        <p><strong>Probeer het later opnieuw.</strong></p>
                        <p>Excuses voor het ongemak.</p>
                    </div>
                </div>
            </div>`;

        this._init();
    }

    _init() {
        this._handleContext();
    }

    _handleContext() {
        this.context === "modal" ? this._setupModal() : this._setupPage();
    }

    _handleFormFlow() {
        this._showLoader();
        this._getContent()
            .then(this._renderContent.bind(this))
            .then(this._initNewModules.bind(this))
            .then(this._hideLoader.bind(this))
            .catch(error => {
                console.error(error);
                this._renderContent(this.errorTemplate);
            });
    }

    _getContent() {
        return new Promise((resolve, reject) => {
            const fetchTimeout = setTimeout(() => {
                reject('FormFlowInitiator module connection timed out');
            }, this.timeout);

            fetch(this.contentUrl, this.fetchProps)
                .then((response) => {
                    if (response.ok) {
                        resolve(response.text());
                    } else {
                        reject('FormFlowInitiator module: ' + response.statusText);
                    }
                })
                .then(() => {
                    clearTimeout(fetchTimeout);
                })
                .catch((error) => {
                    reject('FormFlowInitiator module: ' + error);
                    clearTimeout(fetchTimeout)
                })
        });
    }

    _renderContent(html) {
        this.container.innerHTML = html;
        return true;
    }

    _setupModal() {
        this.trigger = this.element;
        this.container = this.modal.querySelector(".modal__content");

        this.trigger.addEventListener("click", () => {
            this._setLoader(this.modal);
            this._handleFormFlow();
        });
    }

    _setupPage() {
        this.container = this.element;

        this._setLoader(this.container);
        this._handleFormFlow();
    }

    _setLoader(container) {
        this.loader = container.querySelector('.loader');
    }

    _showLoader() {
        this.loader.classList.remove('is-hidden');
    }

    _hideLoader() {
        this.loader.classList.add('is-hidden');
    }

    _initNewModules() {
        const script = this.container.querySelector('#script_formflow');

        // Check if there is a JS script to be initialized, otherwise quit.
        this._handleScript(script);
    }

    _handleScript(script = null) {
        script && eval(script.innerText);
    }
}
